import { create } from "domain";
import * as types from "./_actionTypes";
import degrees from "../../../../utils/API/BackendHelper/college/degrees";

const initialState = {
  colleges: [],
  degrees:[],
  degreesForModal: [],
  loading: false,
  error: null,
  actionLoading: {},
  createLoading: false,
};

const adminCollegeReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_COLLEGES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_COLLEGES_SUCCESS:
      return {
        ...state,
        loading: false,
        colleges: action.payload,
        error: null,
      };

    case types.FETCH_COLLEGES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.FETCH_DEGREES_FOR_COLLEGE_REQUEST:
  return {
    ...state,
    // You can add a loading flag if needed
  };
case types.FETCH_DEGREES_FOR_COLLEGE_SUCCESS:
  return {
    ...state,
      degreesForModal: action.payload,
    error: null,
  };
case types.FETCH_DEGREES_FOR_COLLEGE_FAILURE:
  return {
    ...state,
    error: action.payload,
  };


    case types.APPROVE_COLLEGE_REQUEST:
      return {
        ...state,
        actionLoading: {
          ...state.actionLoading,
          [action.payload]: true,
        },
      };

    case types.APPROVE_COLLEGE_SUCCESS:
      return {
        ...state,
        colleges: state.colleges.map((college) =>
          college.id === action.payload
            ? { ...college, status: "approved" }
            : college
        ),
        actionLoading: {
          ...state.actionLoading,
          [action.payload]: false,
        },
      };

    case types.DELETE_COLLEGE_SUCCESS:
      return {
        ...state,
        colleges: state.colleges.filter(
          (college) => college.id !== action.payload
        ),
        actionLoading: {
          ...state.actionLoading,
          [action.payload]: false,
        },
      };

    case types.TOGGLE_COLLEGE_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        actionLoading: {
          ...state.actionLoading,
          [action.payload]: true,
        },
      };

    case types.TOGGLE_COLLEGE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        colleges: state.colleges.map((college) =>
          college.id === action.payload.collegeId
            ? {
                ...college,
                subscription_active: action.payload.subscriptionActive,
                status: action.payload.subscriptionActive
                  ? "approved"
                  : "inactive",
              }
            : college
        ),
        actionLoading: {
          ...state.actionLoading,
          [action.payload.collegeId]: false,
        },
      };

    case types.TOGGLE_COLLEGE_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        error: action.payload,
        actionLoading: {
          ...state.actionLoading,
          [action.meta?.collegeId]: false,
        },
      };
    case types.APPROVE_COLLEGE_FAILURE:
    case types.DELETE_COLLEGE_FAILURE:
      return {
        ...state,
        error: action.payload,
        actionLoading: {
          ...state.actionLoading,
          [action.meta?.collegeId]: false,
        },
      };

    // College Creation

    case types.CREATE_COLLEGE_REQUEST:
      return {
        ...state,
        createLoading: true,
        error: null,
      };

    case types.CREATE_COLLEGE_SUCCESS:
      return {
        ...state,
        createLoading: false,
        colleges: [...state.colleges, action.payload],
        error: null,
      };

    case types.CREATE_COLLEGE_FAILURE:
      return {
        ...state,
        createLoading: false,
        error: action.payload,
      };

    // Update College
    case types.UPDATE_COLLEGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case types.UPDATE_COLLEGE_SUCCESS:
      return {
        ...state,
        colleges: state.colleges.map(college =>
          college.id === action.payload.id ? action.payload : college
        ),
        loading: false,
        error: null
      };
    case types.UPDATE_COLLEGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default adminCollegeReducer;
